import { createDomain } from 'effector'
import { persist } from 'effector-storage/session'
import { OnboardingService } from './lib/onboarding.service'

export const onboardingDomain = createDomain('onboarding')

export const stepChanged = onboardingDomain.createEvent()
export const userIdObtained = onboardingDomain.createEvent()
export const codeExpirationLoaded = onboardingDomain.createEvent()
export const userObtained = onboardingDomain.createEvent()

export const $currentStep = onboardingDomain.createStore('')
export const $userId = onboardingDomain.createStore(null)
export const $codeExpirationTime = onboardingDomain.createStore(null)
export const $emailVerified = onboardingDomain.createStore('')
export const $user = onboardingDomain.createStore(null)

persist({ store: $codeExpirationTime, key: 'CODE_EXPIRATION_TIME' })
persist({ store: $emailVerified, key: 'EMAIL_VERIFIED' })

// Emitir evento después de persist para notificar que está listo
setTimeout(() => codeExpirationLoaded(), 0)

export const executeStepFx = onboardingDomain.createEffect(
  async ({ step, payload }) => await OnboardingService.executeStep(step, payload)
)

$currentStep.on(stepChanged, (_, step) => step)
$userId.on(userIdObtained, (_, id) => id)
$user.on(userObtained, (_, user) => user)

export const passwordSet = onboardingDomain.createEvent()
export const $password = onboardingDomain.createStore('')
$password.on(passwordSet, (_, password) => password)
persist({ store: $password, key: 'ONBOARDING_PASSWORD' })
